<script lang="ts">
    import { getDBEntries, getDBEntry, putDBEntry } from "../api"
    import { spaNavigate } from "../lib/actions"
    import CardWrapper from "../lib/components/CardWrapper.svelte"
    import CollapsibleWrapper from "../lib/components/CollapsibleWrapper.svelte"
    import Cta from "../lib/components/CTA.svelte"
    import CompanySelect from "../lib/components/formComponents/CompanySelect.svelte"
    import { onChange } from "../lib/components/formComponents/helper"
    import Input from "../lib/components/formComponents/Input.svelte"
    import Loader from "../lib/components/Loader.svelte"
    import TaskTable from "../lib/components/table/TaskTable.svelte"
    import { actionApproval, login, newNotification } from "../lib/store"
    import Select from "../lib/taskSteps/inputfields/Select.svelte"
    import { addTaskToOrder } from "../lib/utils"
    export let orderId: string
    let order: Order, tasks: (TaskOilSpillRemoval | TaskTowing)[]
    async function loadData() {
        // @ts-ignore
        ;[order, tasks] = await Promise.all([
            getDBEntry("order", {
                _id: orderId,
            }),
            getDBEntries("task", {
                orderId: orderId,
            }),
        ])
        orderStatus = order.generalDetails.status || "open"
    }
    loadData()

    async function updateOrder(e: Event, valueChanged: boolean) {
        if (!valueChanged) return
        putDBEntry("order", order)
            .then(() => {
                newNotification({
                    html: "Auftrag aktualisiert",
                    class: "success",
                })
            })
            .catch(() => {
                newNotification({
                    html: "Fehler beim Aktualisieren des Auftrags",
                    class: "error",
                })
            })
    }
    let orderStatus = order?.generalDetails?.status || "open"
    $: if (order && order.generalDetails.status !== orderStatus) {
        order.generalDetails.status = orderStatus
        updateOrder(null, true)
    }
    let innerWidth = 0
    $: isMobile = innerWidth < 1700
</script>

<svelte:window bind:innerWidth="{innerWidth}" />
<section class="actions wrapper">
    <div style="display: flex; width: 100%; justify-content: space-between; margin-bottom: 0px !important;">
        <Cta
            type="BubbleButton"
            icon="solar_arrow-left-outline"
            content="{isMobile ? 'Auftragsliste' : 'zurück zur Übersicht/Neuen Auftrag anlegen'}"
            on:click="{() => {
                spaNavigate('/')
            }}"
        />
    </div>
</section>

<section class="order-detailed wrapper">
    <CardWrapper
        icon="solar_clipboard-text-outline.svg"
        title="{order ? '' : 'Auftrag'}"
        content="{order
            ? [
                  new Date(order.insertTime).toLocaleString('de-DE', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                  }),
                  order.generalDetails.caller.name,
                  order.generalDetails.caller.companyName,
              ]
            : []}"
    >
        <form>
            <CollapsibleWrapper
                icon="solar_call-chat-outline.svg"
                title="Anrufer"
            >
                <div class="row">
                    {#if order}
                        <Input
                            placeholder="Name"
                            id="name"
                            onChange="{onChange}"
                            bind:value="{order.generalDetails.caller.name}"
                            onBlur="{updateOrder}"
                        />

                        <CompanySelect
                            onBlur="{updateOrder}"
                            bind:value="{order.generalDetails.caller.companyName}"
                        />
                        <Input
                            placeholder="Telefon"
                            id="telephone"
                            onChange="{onChange}"
                            onBlur="{updateOrder}"
                            bind:value="{order.generalDetails.caller.telephone}"
                        />
                    {:else}
                        <Loader />
                    {/if}
                </div>
            </CollapsibleWrapper>
            <CollapsibleWrapper
                icon="solar_clipboard-text-outline.svg"
                title="Auftrag"
            >
                <div class="row">
                    {#if order}
                        <Input
                            placeholder="Auftragsnummer (Automatisch Vergeben)"
                            disabled="{true}"
                            id="number"
                            type="number"
                            onBlur="{updateOrder}"
                            onChange="{onChange}"
                            bind:value="{order.generalDetails.number}"
                        />
                        <Select
                            field="{{
                                widget: 'select',
                                label: 'Status',
                                options: [
                                    {
                                        value: 'open',
                                        label: 'Offen',
                                    },
                                    {
                                        value: 'inProgress',
                                        label: 'In Bearbeitung',
                                    },
                                    {
                                        value: 'completed',
                                        label: 'Abgeschlossen',
                                    },

                                    {
                                        value: 'billed',
                                        label: 'Abgerechnet',
                                    },
                                    {
                                        value: 'canceled',
                                        label: 'Storniert',
                                    },
                                ],
                            }}"
                            bind:value="{orderStatus}"
                        />
                    {:else}
                        <Loader />
                    {/if}
                </div>
                <div class="row">
                    {#if order && $login.user.roles.includes("admin")}
                        <Input
                            placeholder="Admin Kommentar"
                            disabled="{false}"
                            id="admin-coment"
                            type="textarea"
                            onBlur="{updateOrder}"
                            onChange="{onChange}"
                            smallTextarea="{true}"
                            bind:value="{order.generalDetails.adminNotes}"
                        />
                    {/if}
                </div>
            </CollapsibleWrapper>
        </form>
        <CollapsibleWrapper
            icon="solar_checklist-outline.svg"
            title="Einsätze"
        >
            <div
                slot="actionButtons"
                class="actionButtons"
            >
                <Cta
                    type="tableButton"
                    icon="mage_plus"
                    on:click="{() => {
                        //@ts-ignore
                        $actionApproval = {
                            modalTitle: 'Einsatz hinzufügen',
                            modalText: `Möchten Sie einen neuen Einsatz zum Auftrag Nr. ${order.generalDetails.number} hinzufügen?`,
                            callback: () => addTaskToOrder(order.id),
                        }
                    }}"
                />
            </div>
            {#if tasks?.length}
                <TaskTable
                    rows="{tasks}"
                    on:click="{(e) => {
                        const task = e.detail
                        $actionApproval = {
                            modalTitle: 'Einsatz öffnen',
                            modalText: `Sind Sie sicher, dass Sie den Einsatz "${task.generalDetails.shortDescription}" gehörend zum Auftrag Nr. ${order.generalDetails.number} öffnen möchten?  Prüfen Sie, ob Sie zugewiesen wurden bzw. ob sie die Erlaubnis haben. Alle änderungen werden Protokolliert!`,
                            callback: () => spaNavigate(`/order/${order.id}/task/${task.id}`),
                        }
                    }}"
                />
            {:else}
                <Loader />
            {/if}
        </CollapsibleWrapper>
    </CardWrapper>
</section>

<style lang="less">
    .actions {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 0.6rem;
    }
    .order-detailed {
        margin-top: 2.4rem;
        display: flex;
        width: 100%;
        form {
            width: 100%;
        }
    }
</style>
